// Tutorial titles extracted from the original Unity game
export const TUTORIAL_TITLES: { [constellation: string]: string[] } = {
  'Bear': [
    "How to move",
    "How to race",
    "Predator",
    "Race defence",
    "Bear Challenge"
  ],
  'Crane': [
    "Crane Movement",
    "Bird Type",
    "Crane Challenge"
  ],
  'Frog': [
    "Frog Movement",
    "Wall Climb",
    "Poison Ability",
    "Lily Pad Ability", 
    "Frog Challenge"
  ],
  'Goat': [
    "Goat Movement",
    "Hop Ability",
    "Feint Death Ability",
    "Goat Challenge"
  ],
  'Monkey': [
    "Monkey Movement",
    "Swing Ability",
    "Monkey Gamble",
    "Consume Ability",
    "Monkey Challenge"
  ],
  'Fungi': [
    "Fungi Movement",
    "Meadow Maker Ability",
    "Zombify Ability",
    "Fungi challenge"
  ],
  'Octopus': [
    "Octopus Movement",
    "Entangle Ability",
    "Octopus Attack",
    "Ink Ability",
    "Octopus Weakness",
    "The beach gangs"
  ],
  'Virus': [
    "Virus Movement",
    "Virus Attack",
    "Virus Challenge"
  ],
  'Penguin': [
    "Penguin Movement",
    "Penguin Rotation",
    "Penguin Challenge 1",
    "Penguin Challenge 2"
  ],
  'Rhino': [
    "Rhino Movement",
    "Defence Ability",
    "Charge Ability",
    "Lane Ability",
    "Rhino Challenge"
  ],
  'Snake': [
    "Snake Movement",
    "Strike Ability", 
    "Shed Ability",
    "Snake Challenge"
  ],
  'Tree': [
    "Tree Movement",
    "Housing",
    "Tree Challenge"
  ],
  'Wolf': [
    "Wolf movement",
    "Going it alone",
    "Wolf Challenge"
  ]
};

// Tutorial descriptions for developers - explaining teaching objectives and design intent
export const TUTORIAL_DESCRIPTIONS: { [constellation: string]: string[] } = {
  'Bear': [
    "Teach the player how to select and move|||Select the light bear by clicking on it, move to one of the highlighted squares|||Move 2 times to complete the tutorial",
    "Introduce the king piece concept and race victory condition to the player|||Race your light bear king to the backrank to win the game",
    "Introduce the predator type mechanic - Bears cannot be captured by certain piece types (Crane, Penguin, Goat). User can safely advance their bear to achieve race victory.",
    "Teach players how to defend against king race|||Prevent the dark crane king from reaching your backrank for 7 turns, OR capture the dark crane king, OR race your bear king to row 7|||You are playing as light",
    "Challenge scenario testing bear mechanics. Bears can break through Rhino frontal defenses. User must navigate bears strategically against rhino opponents to achieve victory."
  ],
  'Crane': [
    "Teach Crane's movement pattern (1-2 spaces in any straight line). User can win by either racing to the opposite side or capturing the enemy king.",
    "Introduce the bird type limitation - Cranes cannot capture certain piece types (Bear, Tree, Rhino, Wolf). User must work around this restriction to achieve victory.",
    "Challenge tutorial testing Crane's mobility advantage. User must use the Crane's superior movement range to navigate around Wolf pieces and achieve victory."
  ],
  'Frog': [
    "Teach Frog's basic diagonal movement (2 squares diagonally). Movement is blocked by walls and friendly pieces.",
    "Introduce Frog's special wall-climbing ability - when touching a side wall, Frog can move 1 space up or down along the wall.",
    "Teach Frog's poison mechanic - any piece that captures a Frog becomes immobilized for one turn. Poison also removes Bear's immunity to Monkey attacks.",
    "Introduce Frog's lily pad ability - an unmoved Frog king can jump to any unoccupied or enemy square in the first 3 ranks (except Rhino pieces).",
    "Challenge tutorial where user must eliminate all enemy Cranes using Frog's movement abilities within the turn limit."
  ],
  'Goat': [
    "Teach Goat's basic movement (1 square in any direction, like a king in chess).",
    "Introduce Goat's chain-hopping ability - Goats can traverse across chains of adjacent pieces, potentially crossing the entire board in one move.",
    "Teach Goat's feint death defensive ability - when threatened, Goat can feint death and become invulnerable (except to Rhino/Tree). Goat revives when safe.",
    "Challenge scenario where user practices defensive play against Goats. Multiple win conditions available (race or capture)."
  ],
  'Monkey': [
    "Teach Monkey's vaulting movement - can move 1 space or vault over pieces multiple times in sequence. User achieves race victory with Monkey king.",
    "Introduce Monkey's tree-swing bonus - vaulting over Tree pieces grants an additional turn. User must utilize this for efficient movement.",
    "Teach Monkey's risk/reward dice mechanics - jumping over enemies requires dice roll (1 = captured). Attacking Bears requires 5-6 roll or Monkey is captured.",
    "Introduce Monkey-Fungi interaction - capturing Fungi pieces grants Monkey an extra turn.",
    "Challenge tutorial combining all Monkey mechanics. User must navigate complex board state to achieve victory."
  ],
  'Fungi': [
    "Teach Fungi's basic movement (1 square in any direction).",
    "Introduce Fungi's area control - Fungi immobilizes Trees within 1 square radius. Trees also cannot approach Fungi.",
    "Teach Fungi's zombification mechanic - when captured, the capturing piece switches sides for one turn and becomes Fungi.",
    "Challenge demonstrating Fungi's unique survival mechanic - even when captured, Fungi gets one more turn as the capturing piece before being removed."
  ],
  'Octopus': [
    "Teach Octopus basic movement (1 square in any direction).",
    "Introduce Octopus entanglement - can immobilize pieces on diagonal squares before or after moving. Entanglement lasts until Octopus moves.",
    "Teach Octopus capture limitation - can only capture on orthogonal squares (up/down/left/right), not diagonally.",
    "Introduce Octopus ink ability - creates 3 fake copies that are visually identical to real Octopus, confusing opponent.",
    "Teach Octopus limitations - cannot entangle Trees or Mushrooms. Goats can escape entanglement by feinting death.",
    "Challenge tutorial testing all Octopus mechanics in a balanced scenario."
  ],
  'Virus': [
    "Teach Virus's unique movement - can only move to occupied squares, 2 spaces maximum, can move multiple times per turn (must infect pieces).",
    "Introduce Virus capture mechanic - when moving from one piece to another, captures the piece it left behind (friend or foe).",
    "Challenge teaching Virus selection UI - must hold and click infected pieces to control the Virus within. Goal is to defeat enemy pieces."
  ],
  'Penguin': [
    "Teach Penguin's directional sliding movement - moves in facing direction until hitting piece/wall, then must choose new facing direction.",
    "Introduce Penguin rotation mechanic - can rotate in place instead of moving. UI: select penguin then click it again to rotate.",
    "Navigation puzzle testing Penguin movement and rotation mechanics within turn limit.",
    "Defensive challenge applying Penguin mechanics in combat scenario."
  ],
  'Rhino': [
    "Teach Rhino's basic movement (2 forward, 1 diagonal back) and introduce charge ability (3 forward, once per game).",
    "Introduce Rhino's defensive ability - immune to attacks from above and diagonal-above (except Bears can attack frontally).",
    "Teach Rhino charge details - charges 3 spaces forward once per game, trampling and capturing all pieces in path (including feinted Goats).",
    "Introduce Rhino's lane-swap ability - can swap positions with another unmoved piece.",
    "Challenge against Bears (which can break Rhino's defense). User must use multiple Rhinos strategically to achieve race victory."
  ],
  'Snake': [
    "Teach Snake's movement (2 spaces in straight lines, blocked by walls/friendly pieces).",
    "Introduce Snake's strike ability - can attack 3 squares forward if path is clear and enemy is exactly 3 squares away.",
    "Teach Snake's shed ability - once per game, can teleport back to any unoccupied square in the first rank (escape mechanism).",
    "Challenge combining all Snake mechanics against enemy pieces."
  ],
  'Tree': [
    "Teach Tree's unlimited linear movement (forward, left, or right until blocked).",
    "Introduce Tree's housing ability - can carry other pieces, protecting them from non-climbing enemies. Housed pieces move with the Tree.",
    "Challenge requiring strategic use of Tree movement and housing mechanics to achieve victory."
  ],
  'Wolf': [
    "Teach Wolf's L-shaped knight movement pattern.",
    "Introduce lone wolf mechanic - solo Wolves gain enhanced movement/abilities. User must utilize this advantage.",
    "Challenge scenario with dual wolf kings, testing advanced wolf tactics."
  ]
};

export function getTutorialTitle(constellation: string, tutorialIndex: number): string {
  const titles = TUTORIAL_TITLES[constellation];
  if (!titles || tutorialIndex < 0 || tutorialIndex >= titles.length) {
    return `${constellation} Tutorial ${tutorialIndex + 1}`;
  }
  return titles[tutorialIndex];
}

export function getTutorialDescription(constellation: string, tutorialIndex: number): string {
  const descriptions = TUTORIAL_DESCRIPTIONS[constellation];
  if (!descriptions || tutorialIndex < 0 || tutorialIndex >= descriptions.length) {
    return `Learn about the ${constellation} piece in this tutorial.`;
  }
  return descriptions[tutorialIndex];
} 